(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yz-barra-oferta"] && !Shopify.designMode) return;
  try {
    
(function(){
  function dos(n){return (n<10?'0':'')+n;}
  function objetivo(el){
    var modo=el.getAttribute('data-modo');
    var ahora=new Date();
    if(modo==='horas'){
      var horas=parseInt(el.getAttribute('data-horas'),10)||8;
      var clave='yzBarraOferta_'+horas;
      var fin=parseInt(localStorage.getItem(clave),10);
      if(!fin||isNaN(fin)||fin<ahora.getTime()){
        fin=ahora.getTime()+horas*3600*1000;
        try{localStorage.setItem(clave,fin);}catch(e){}
      }
      return fin;
    }
    var medianoche=new Date(ahora.getFullYear(),ahora.getMonth(),ahora.getDate()+1,0,0,0,0);
    return medianoche.getTime();
  }
  function pintar(el){
    var fin=objetivo(el);
    var dif=Math.max(0,fin-Date.now());
    var s=Math.floor(dif/1000);
    var h=Math.floor(s/3600);var m=Math.floor((s%3600)/60);var seg=s%60;
    var eh=el.querySelector('[data-yz-horas]');var em=el.querySelector('[data-yz-min]');var es=el.querySelector('[data-yz-seg]');
    if(eh)eh.textContent=dos(h);
    if(em)em.textContent=dos(m);
    if(es)es.textContent=dos(seg);
  }
  function iniciar(){
    var barras=document.querySelectorAll('[data-yz-barra-oferta]');
    barras.forEach(function(el){pintar(el);setInterval(function(){pintar(el);},1000);});
  }
  if(document.readyState!=='loading'){iniciar();}else{document.addEventListener('DOMContentLoaded',iniciar);}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yz-carrusel-producto"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(track){
    if(track.__yzloop) return;
    track.__yzloop = 1;
    var half = track.scrollWidth / 2;
    function measure(){ half = track.scrollWidth / 2; }
    measure();
    window.addEventListener('load', measure);
    window.addEventListener('resize', measure, {passive:true});
    setTimeout(measure, 1200);
    track.addEventListener('scroll', function(){
      if(half < 40) return;
      if(track.scrollLeft >= half){ track.scrollLeft -= half; }
      else if(track.scrollLeft < 0){ track.scrollLeft += half; }
    }, {passive:true});
  }
  document.querySelectorAll('[data-yz-carrusel-track]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yz-comunidad"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(section){
    var vp = section.querySelector('[data-yz-com-viewport]');
    var track = section.querySelector('[data-yz-com-track]');
    if(!vp || !track || vp.__yzcom) return;
    vp.__yzcom = 1;
    var loopSeconds = parseFloat(getComputedStyle(section).getPropertyValue('--yz-com-vel')) || 45;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var paused=false, resumeTimer=null, lastTs=null;
    function half(){ return track.scrollWidth/2; }
    function pause(){ paused=true; if(resumeTimer){clearTimeout(resumeTimer);resumeTimer=null;} }
    function resumeSoon(){ if(resumeTimer)clearTimeout(resumeTimer); resumeTimer=setTimeout(function(){paused=false;lastTs=null;},1600); }
    ['pointerdown','touchstart','wheel','mouseenter'].forEach(function(e){ vp.addEventListener(e,pause,{passive:true}); });
    ['pointerup','touchend','mouseleave'].forEach(function(e){ vp.addEventListener(e,resumeSoon,{passive:true}); });
    vp.addEventListener('scroll', function(){ var h=half(); if(!h)return; if(vp.scrollLeft>=h){vp.scrollLeft-=h;} else if(vp.scrollLeft<0){vp.scrollLeft+=h;} }, {passive:true});
    if(!('ontouchstart' in window)){
      var down=false,sx=0,sl=0,moved=false;
      vp.addEventListener('mousedown',function(e){down=true;moved=false;sx=e.pageX;sl=vp.scrollLeft;pause();});
      window.addEventListener('mousemove',function(e){if(!down)return;var dx=e.pageX-sx;if(Math.abs(dx)>4)moved=true;vp.scrollLeft=sl-dx;});
      window.addEventListener('mouseup',function(){if(!down)return;down=false;resumeSoon();});
      vp.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();}},true);
    }
    function step(ts){
      var h=half();
      var sp = (reduce||h<=0)?0:(h/loopSeconds);
      if(sp>0 && !paused){
        if(lastTs===null)lastTs=ts;
        var dt=(ts-lastTs)/1000; lastTs=ts;
        vp.scrollLeft += sp*dt;
        if(vp.scrollLeft>=h) vp.scrollLeft-=h;
      } else { lastTs=null; }
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  document.querySelectorAll('[data-yz-comunidad]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yz-resenas"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(section){
    var vp = section.querySelector('[data-yz-resenas-viewport]');
    var track = section.querySelector('[data-yz-resenas-track]');
    if (!vp || !track) return;
    var half = track.scrollWidth / 2;
    if (!half) return;
    var durAttr = getComputedStyle(section).getPropertyValue('--yz-res-dur') || '45s';
    var loopSeconds = parseFloat(durAttr) || 45;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var pxPerSec = reduceMotion ? 0 : (half / loopSeconds);
    var paused = false;
    var resumeTimer = null;
    var lastTs = null;

    function pause(){
      paused = true;
      if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; }
    }
    function scheduleResume(){
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function(){ paused = false; lastTs = null; }, 1500);
    }

    ['pointerdown','touchstart','mouseenter'].forEach(function(ev){
      vp.addEventListener(ev, pause, {passive:true});
    });
    ['pointerup','touchend','mouseleave'].forEach(function(ev){
      vp.addEventListener(ev, scheduleResume, {passive:true});
    });

    vp.addEventListener('scroll', function(){
      if (vp.scrollLeft >= half) { vp.scrollLeft -= half; }
      else if (vp.scrollLeft < 0) { vp.scrollLeft += half; }
    }, {passive:true});

    function step(ts){
      if (pxPerSec > 0 && !paused) {
        if (lastTs === null) lastTs = ts;
        var dt = (ts - lastTs) / 1000;
        lastTs = ts;
        vp.scrollLeft += pxPerSec * dt;
        if (vp.scrollLeft >= half) vp.scrollLeft -= half;
      } else {
        lastTs = null;
      }
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  document.querySelectorAll('[data-yz-resenas]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();
})();
